export default "__VITE_ASSET__DjCs2pLa__"